/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import {css, setup} from 'goober'
import React, {useMemo} from 'react'
import {
  resolveValue,
  Toast,
  toast,
  ToastBar,
  Toaster,
  useToaster,
} from 'react-hot-toast'

/*
 * 使用 useToaster 对 Toaster 进行自定义主要做了以下几件事
 * 1. toastModal 单独显示，独立于Toast的位置队列 不进行 getPositionStyle('offset') 便宜
 * 2. 调整toastModal(9998)和Toast(9999)的层级关系
 * 3. toastModal 与 startPause/endPause 冲突，用不到暂停所有先屏蔽
 */
type ToasterProps = React.ComponentProps<typeof Toaster>

setup(React.createElement)
const activeClass = css`
  > * {
    pointer-events: auto;
  }
`

export const createRectRef =
  (onRect: (rect: DOMRect) => void) => (el: HTMLElement | null) => {
    if (el) {
      setTimeout(() => {
        const boundingRect = el.getBoundingClientRect()
        onRect(boundingRect)
      })
    }
  }
export const prefersReducedMotion = (() => {
  // Cache result
  let shouldReduceMotion: boolean | undefined

  return () => {
    if (shouldReduceMotion === undefined && typeof window !== 'undefined') {
      const mediaQuery = matchMedia('(prefers-reduced-motion: reduce)')
      shouldReduceMotion = !mediaQuery || mediaQuery.matches
    }
    return shouldReduceMotion
  }
})()
const getPositionStyle = (
  position: ToasterProps['position'],
  offset: number,
  zIndex: number,
  center: boolean
): React.CSSProperties => {
  let style: React.CSSProperties
  if (center) {
    style = {
      top: '50%',
      left: '0px',
      transform: 'translateY(-50%)',
      justifyContent: 'center',
    }
  } else {
    const top = position.includes('top')
    const verticalStyle: React.CSSProperties = top ? {top: 0} : {bottom: 0}
    const horizontalStyle: React.CSSProperties = position.includes('center')
      ? {
          justifyContent: 'center',
        }
      : position.includes('right')
      ? {
          justifyContent: 'flex-end',
        }
      : {}
    style = {
      transform: `translateY(${offset * (top ? 1 : -1)}px)`,
      ...verticalStyle,
      ...horizontalStyle,
    }
  }

  return {
    left: 0,
    right: 0,
    display: 'flex',
    zIndex,
    position: 'absolute',
    transition: prefersReducedMotion()
      ? undefined
      : `all 230ms cubic-bezier(.21,1.02,.73,1)`,
    ...style,
  }
}

export const DEFAULT_OFFSET = 16

const Index = ({
  reverseOrder,
  position = 'top-center',
  toastOptions,
  gutter,
  children,
  containerStyle,
  containerClassName,
}: ToasterProps) => {
  const {toasts, handlers} = useToaster(toastOptions)
  const allToasts = useMemo(() => {
    const common: Toast[] = []
    const toastModal: Toast[] = []

    let hasLoading = false
    toasts.forEach((v) => {
      if (v.className === 'ToastModal') {
        toastModal.push(v)
      } else {
        common.push(v)
      }
      if (v.type === 'loading') {
        hasLoading = true
      }
    })
    let style = containerStyle
    if (!style) {
      style = {}
    }
    if (hasLoading) {
      delete style.pointerEvents
    } else {
      style.pointerEvents = 'none'
    }
    return {
      common,
      toastModal,
      style,
    }
  }, [toasts])
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 9999,
        top: DEFAULT_OFFSET,
        left: DEFAULT_OFFSET,
        right: DEFAULT_OFFSET,
        bottom: DEFAULT_OFFSET,
        // loading 要阻止下面可操作
        // pointerEvents: 'none',
        ...allToasts.style,
      }}
      className={containerClassName}
      //   暂时用不到暂停
      //   onMouseEnter={handlers.startPause}
      //   onMouseLeave={handlers.endPause}
    >
      {allToasts.common.map((t) => {
        const toastPosition = t.position || position
        const offset = handlers.calculateOffset(t, {
          reverseOrder,
          gutter,
          defaultPosition: position,
        })
        const positionStyle = getPositionStyle(
          toastPosition,
          offset,
          9999,
          t.className === 'onlyToast'
        )

        const ref = t.height
          ? undefined
          : createRectRef((rect) => {
              handlers.updateHeight(t.id, rect.height)
            })

        return (
          <div
            ref={ref}
            className={t.visible ? activeClass : ''}
            key={t.id}
            style={positionStyle}
          >
            {t.type === 'custom' ? (
              resolveValue(t.message, t)
            ) : children ? (
              children(t)
            ) : (
              <ToastBar toast={t} position={toastPosition} />
            )}
          </div>
        )
      })}
      {allToasts.toastModal.map((t) => {
        const toastPosition = t.position || position
        const positionStyle = getPositionStyle(toastPosition, 0, 9998, false)
        return (
          <div
            className={t.visible ? activeClass : ''}
            key={t.id}
            style={{
              ...positionStyle,
              ...t.style,
            }}
          >
            {resolveValue(t.message, t)}
          </div>
        )
      })}
    </div>
  )
}
export const onlyToast = (() => {
  let id
  return (...arg: Parameters<typeof toast>) => {
    if (id) {
      toast.remove(id)
    }
    if (!arg[1]) {
      arg[1] = {}
    }
    arg[1].className = `onlyToast`
    arg[1].style = {
      textAlign: 'center',
      ...arg[1].style,
      animation: 'none',
    }
    id = toast(...arg)
  }
})()
export default Index
